<template>
	<div  class="ssoModuleFilter" @keyup.enter="doEnterThings()">
		<card class="majorFilter-card" >
			<div class="majorFilter row px-3">
				<div class="firstFilter-row"> 
					<div class="base-search col-md-3 px-0 mr-3" :class="[{'d-none':bInComplexPage}]">
						<ReInputSearchDropType 
							:disabled="bInComplexPage"
							name="BigSearch"
							placeholder="Поиск по  метро, району, ЖК, застройщику"
							:MinTxtLen="2"
							v-model="BigSearch"
							:objApiMethod="{obj:'NovoObj' ,flt:{name:''}}"
							strApiMethodKey="name"
							v-on:change="OnBigSearch"
						/>
					</div>
					<div class="year-search mr-3 mb-2" :class="[{'d-none':!bInComplexPage}]">
						<el-select
							class="col-md px-0 select-primary"
							v-model="objFilterData.dcorptr.value" 
							filterable
							clearable
							placeholder="Выбор корпуса"
							size="large"
						>
							<el-option
								class="select-primary"
								v-for="item in objFilterData.dcorptr.options"
								:key="item.value"
								:label="item.label"
								:value="item.value"
							>
							</el-option>
						</el-select>
					</div>
					<!--div class="map-search mr-3 mb-2">
						<base-button :disabled="bInComplexPage" type="" simple><i class="tim-icons icon-square-pin mr-2"></i>Выделить на карте</base-button>
						<yandex-map
							:settings="yamap_settings"
							:coords="yamap_coords"
							:zoom="yamap_zoom"
							:controls="yamap_controls"
							>
						
							<ymap-marker
									:coords="yamap_markers.coords"
									:marker-id="yamap_markers.id"
									marker-type="placemark"
							/>

						</yandex-map>
					</div-->
					<div class="year-search mr-3 mb-2">
						<div class="d-flex">
							<el-select
								class="w-100 px-0 select-primary"
								v-model="objFilterData.denddt.value" 
								filterable
								clearable
								placeholder="Срок сдачи"
								size="large"
							>
								<el-option
									class="select-primary"
									v-for="item in objFilterData.denddt.options"
									:key="item.value"
									:label="item.label"
									:value="item.value"
								>
								</el-option>
							</el-select>
							<base-button type="danger" class="no-border my-0" simple icon @click="objFilterData.denddt.value = '';"><i class="d-inline-block tim-icons icon-simple-remove"></i></base-button>
						</div>
					</div>
					<div class="price-search mr-3 mb-2"> <!--такого компонента нет. Тут должен быть дроп-лист с двумя колонками выбора цены: От и До-->
						<ReInputRange class="mb-3" v-model="objFilterData.amount.value" placeholder="Цена от|до" inputType="money"/>
						<!--base-input
							placeholder="Цена до"
							v-model="objFilterData.dmaxamount.value"
							autocomplete="off"
						></base-input-->
					</div>
					
					<div class=" type-search mr-3 mb-2">
						<el-select
							class="overflow-overlay col-md px-0 select-primary"
							v-model="objFilterData.drooms.value" 
							:multiple="true"
							:filterable="true"
							clearable
							placeholder="Тип квартиры"
							size="large"
						>
							<el-option
								class="select-primary"
								v-for="item in objFilterData.drooms.options"
								:key="item.value"
								:label="item.label"
								:value="item.value"
							>
							</el-option>
						</el-select>
					</div>
					<div class="allFilters">
						<base-button @click="ShowFilter()" type="primary" simple ><i class="d-inline-block tim-ic ic-filter mr-2"></i><span>Все фильтры</span><span class="badge badge-pill badge-primary ml-2" v-if="optCount != ''">{{optCount}}</span></base-button>
					</div>
					<div class="applyFilter">
						<base-button @click="OnFilterApply()" type="success">Применить</base-button>
					</div>

				</div>
				<div class="firstFilter-row filter-tags mt-2">
					<el-tag
						v-for="tag in filterTags"
						:key="tag.param_id"
						size="small"
						:closable="true"
						:close-transition="false"
						@close="handleClose(tag)"
						:type="'primary'"
					>
					{{ tag.name }}
					</el-tag>
					<span v-if="optCount != ''" class="el-tag el-tag--danger el-tag--small el-tag--light"> Сбросить всё <i class="el-tag__close el-icon-close" @click="OnFilterReset()"></i></span>
				</div>

			</div>	

			<hr v-show="this.bShowFilter">

			<div class="moreFilter mt-3" v-show="bShowFilter">
				<div class="filter-row">
					<div class="col-md-4 col-sm-6 pl-0">
						<div class="mr-3 mb-2 flat-corp-width"> <h5 class="col-form-label col-md-12">Этаж</h5>
							<ReInputRange  v-model="objFilterData.floor.value" placeholder="от|до" inputType="number"/>
							<base-checkbox v-model="objFilterData.dfoorlast.value" inline>Последний</base-checkbox>
							<base-checkbox v-model="objFilterData.dfloornotfst.value" inline>Кроме первого</base-checkbox>
							<base-checkbox v-model="objFilterData.dfloornotlst.value" inline>Кроме последнего</base-checkbox>
						</div>
						<div class="mr-3 mb-2 flat-corp-width" v-if="!bInComplexPage"> <h5 class="col-form-label col-md-12 pb-0 mt-2">До метро</h5>
							<ReFromMetro
								v-model="objFilterData.FromMetro.value" 
								placeholder="мин"
								label="Расстояние до метро"
								:options="objFilterData.FromMetro.options"/>
						</div>
						<div class="mr-3 mb-2 flat-corp-width" :class="[{'d-none':!bInComplexPage}]">
							<base-input
								placeholder="id или номер квартиры"
								addon-left-icon="tim-icons icon-zoom-split"
								v-model="objFilterData.dflatidnumber.value"
								autocomplete="off"
							></base-input>
						</div>
					</div>
					<div class="col-md-4 col-sm-6 pl-0">
						<div class="mr-3 mb-2 flat-corp-width"> <!--h5 class="col-form-label col-md-12">Площади</h5-->
							<h5 class="col-form-label col-md-12"> Площадь приведенная</h5>
							<ReInputRange class="mb-2" v-model="objFilterData.stotal.value" placeholder="от|до" inputType="number"/>
							<h5 class="col-form-label col-md-12">Площадь кухни</h5>
							<ReInputRange class="mb-3" v-model="objFilterData.skitchen.value" placeholder="от|до" inputType="number"/>
						</div>
					</div>							

					<div class="col-md-4 col-sm-6 pl-0">
						<div class="mr-3 mb-2 flat-corp-width"><h5 class="col-form-label col-md-12">Удобства</h5>
							<div class="d-flex">
							<el-select
								class="w-100 px-0 select-primary mb-3"
								v-model="objFilterData.dwatercloset.value" 
								placeholder="Санузел"
								size="large"
								clearable
							>
								<el-option
									class="select-primary"
									v-for="item in objFilterData.dwatercloset.options"
									:key="item.value"
									:label="item.label"
									:value="item.value"
								>
								</el-option>
							</el-select>
							<base-button type="danger" class="no-border my-0" simple icon @click="objFilterData.dwatercloset.value = '';"><i class="d-inline-block tim-icons icon-simple-remove"></i></base-button>
							</div>
							<el-select
								class="overflow-overlay col-md px-0 select-primary mb-3 "
								v-model="objFilterData.ddecoration.value" 
								placeholder="Отделка"
								size="large"
								:multiple="true"
								clearable
								style="padding-right: 38px!important;"
							>
								<el-option
									class="select-primary"
									v-for="item in objFilterData.ddecoration.options"
									:key="item.value"
									:label="item.label"
									:value="item.value"
								>
								</el-option>
							</el-select>
							<div class="d-flex">
							<el-select
								class="w-100 px-0 select-primary mb-3"
								v-model="objFilterData.dsbalcony.value" 
								placeholder="Балкон"
								size="large"
								clearable
							>
								<el-option
									class="select-primary"
									v-for="item in objFilterData.dsbalcony.options"
									:key="item.value"
									:label="item.label"
									:value="item.value"
								>
								</el-option>
							</el-select>
							<base-button type="danger" class="no-border my-0" simple icon @click="objFilterData.dsbalcony.value = '';"><i class="d-inline-block tim-icons icon-simple-remove"></i></base-button>
							</div>
						</div>
					</div>

				</div>
				<div class="filter-row">
					<div class="col-md-4 col-sm-6 pl-0">						
						<div class="mr-3 mb-2 flat-corp-width"> <h5 class="col-form-label col-md-12">Оплата</h5>
							<div>
								<el-select
									class="overflow-overlay col-md px-0 select-primary mb-2 "
									filterable
									clearable
									v-model="objFilterData.dbanks.value" 
									placeholder="Банки"
									size="large"
									:multiple="true"
								>
									<el-option
										class="select-primary"
										v-for="item in objFilterData.dbanks.options"
										:key="item.value"
										:label="item.label"
										:value="item.value"
									>
									</el-option>
								</el-select>
							</div>
							<div>
								<base-checkbox v-model="objFilterData.dinstallment.value" inline>Рассрочка</base-checkbox>
								<base-checkbox v-model="objFilterData.dmortgage.value" inline>Ипотека</base-checkbox>
								<base-checkbox v-model="objFilterData.dsubsidy.value" inline>Субсидии</base-checkbox>
								<base-checkbox v-model="objFilterData.dmaternitycapital.value" inline>Материнский капитал</base-checkbox>
								<base-checkbox v-model="objFilterData.dmilitarymortgage.value" inline>Военная ипотека</base-checkbox>
							</div>
						</div>

					</div>

					<div class="col-md-4 col-sm-6 pl-0">										
						<div class="mr-3 mb-2 flat-corp-width"> <h5 class="col-form-label col-md-12">Иное</h5>
							<div class="d-flex">
							<el-select
								class="w-100 px-0 select-primary mb-3"
								v-model="objFilterData.dAppartaments.value" 
								placeholder="Апартаменты не имеют значения"
								clearable
								size="large"
							>
								<el-option
									class="select-primary"
									v-for="item in objFilterData.dAppartaments.options"
									:key="item.value"
									:label="item.label"
									:value="item.value"
								>
								</el-option>
							</el-select>
							<base-button type="danger" class="no-border my-0" simple icon @click="objFilterData.dAppartaments.value = '';"><i class="d-inline-block tim-icons icon-simple-remove"></i></base-button>
							</div>
						</div>
					</div>

					<div class="col-md-4 col-sm-6 pl-0">
						<div class="mr-3 mb-2 flat-corp-width">
							<h5 class="col-form-label col-md-12">Инвестиции</h5>
							<ReInputRange class="mb-2" v-model="objFilterData.dinvestments.value" placeholder="от|до" inputType="number"/>

							<base-checkbox v-model="objFilterData.donsale.value" inline>Показать проданные</base-checkbox>
							<base-checkbox v-model="objFilterData.donreservation.value" inline>Показать бронь</base-checkbox>
						</div>
						<!--div class="mr-3 mb-2">
							<base-checkbox v-model="objFilterData.dustupki.value" inline>Показать уступки</base-checkbox>
						</div-->
						<base-checkbox v-model="objFilterData.dnotworkgk.value" inline :class="[{'d-none':bInComplexPage}]">Показать ЖК, с которыми мы не работаем</base-checkbox>
					</div>
				</div>

			</div>
		</card>
	</div>
</template>
<script>

import { Select, Option } from 'element-ui';
import { BaseCheckbox, /*BaseRadio, BaseSwitch*/ } from 'src/components/index';
import ReFromMetro from "src/our_components/ReFromMetro.vue";
import ReInputRange from "src/our_components/ReInputRange.vue";
import { Tag } from 'element-ui';
import ReInputSearchDropType from 'src/our_modules/SearchSendObjects/ReInputSearchDropType.vue';
// import ReSearchStaffClients from 'src/our_components/ReSearchStaffClients.vue';

export default {
	name: 'ssoModuleFilter',
	components: {
		[Option.name]: Option,
		[Select.name]: Select,
		BaseCheckbox,
		// BaseRadio,
		// BaseSwitch,
		ReFromMetro,
		ReInputRange,
		[Tag.name]: Tag,
		ReInputSearchDropType,
		// ReSearchStaffClients,
	},
	props: {
		value: String,
		complex_corp_options: {
			type: Array,
			default: function(){return [];}
		}
	},
	data() {
		return {
			bShowFilter: false,
			BigSearch: {inputText: '', selectedVal:''},
			objGetParams: {},
			masExcludeParams: ['page','p','c2p','AddComplexMinFlatsBig','dSortOrder','dSortType','dSearchType','client_id','taskend_id','task_id','service_id'],
			optCount: '',
			filterTags:[],
			yamap_settings: {
				apiKey: '',
				lang: 'ru_RU',
				coordorder: 'latlong',
				version: '2.1'
			},
			yamap_coords: [59.93984485554249, 30.314527237792984],
			yamap_zoom: 11,
			yamap_controls:['zoomControl','typeSelector'],
			yamap_markers:{
				coords: [59.93984485554249, 30.314527237792984],
				id: '1',
			},
			objFilterData: { //Правила: 1) Имя свойсва - это параметр отправляем в GET метод АПИ; 2) одно свойство - одно поле/компонет. 3) В свойстве поле value привязывать к v-model поля/компонета. 4) Все поля/компонета должны уметь v-model
				dSearchType:{value:'complex', elementType: 'input-hidden', value_default: ''}, // flat||complex||complexmap
				dSortType:{value:'dt_upd|d', elementType: 'input-hidden', value_default: ''}, // cost||actual
				//dSortOrder:{value:'a', elementType: 'input-hidden', value_default: ''}, // a||d
				AddComplexMinFlatsBig:{value:'', elementType: 'input-hidden', value_default: ''},
				drooms:{value:'', catalog:'CAT_ROOMS', options:[], tagText:'Тип квартиры', elementType: 'select', value_default: ''},
				denddt:{value:'', catalog:'CAT_D_ENDS', options:[], tagText:'Срок сдачи', elementType: 'select', value_default: ''},
				dcorptr:{value:'', options:[], tagText:'Корпус', elementType: 'select', value_default: ''},
				dwatercloset:{value:'', options:[{value:'1',label:'Совмещенный'},{value:'2',label:'Раздельный'},{value:'3',label:'Два и более санузла'}], tagText:'Санузел', elementType: 'select', value_default: ''},
				ddecoration:{value:'', catalog:'CAT_DECORATION', options:[], tagText:'Отделка', elementType: 'select', value_default: ''},
				dsbalcony:{value:'', options:[{value:'1',label:'Терраса'},{value:'2',label:'Балкон'},{value:'3',label:'Лоджия'}], tagText:'Балкон', elementType: 'select', value_default: ''},
				//dinvestments:{value:'', options:[{value:'1',label:'Менее 10%'},{value:'2',label:'10% - 20%'},{value:'3',label:'Более 20%'}], tagText:'Инвестиции', elementType: 'select', value_default: ''},
				dAppartaments:{value:'', options:[{value:'1',label:'Только апартаменты'},{value:'2',label:'Кроме апартаментов'}], tagText:'Аппартаменты', elementType: 'select', value_default: ''},
				dbanks:{value:'', catalog:'CAT_BANKS', options:[], tagText:'Банки', elementType: 'select', value_default: ''},
				dinstallment:{value:false, tagText:'Рассрочка', elementType: 'checkbox', value_default: false},
				dmortgage:{value:false, tagText:'Ипотека', elementType: 'checkbox', value_default: false},
				dsubsidy:{value:false, tagText:'Субсидии', elementType: 'checkbox', value_default: false},
				dmaternitycapital:{value:false, tagText:'Материнский капитал', elementType: 'checkbox', value_default: false},
				dmilitarymortgage:{value:false, tagText:'Военная ипотека', elementType: 'checkbox', value_default: false},
				donsale:{value:false, tagText:'Проданные', elementType: 'checkbox', value_default: false},
				donreservation:{value:false, tagText:'Бронь', elementType: 'checkbox', value_default: false},
				//dustupki:{value:false, elementType: 'checkbox', value_default: false},
				//dworkgk:{value:false, tagText:'ЖК с кураторами', elementType: 'checkbox', value_default: false},
				dnotworkgk:{value:false, tagText:'ЖК c кураторми и без', elementType: 'checkbox', value_default: false},
				dflatidnumber:{value:'', tagText:'Номер квартиры', elementType: 'input', value_default: ''},
				dcorptr:{value:'', options:this.complex_corp_options, tagText:'Корпус', elementType: 'select', value_default: ''},
				dfoorlast:{value:false, tagText:'Этаж последний', elementType: 'checkbox', value_default: false},
				dfloornotfst:{value:false, tagText:'Этаж не первый', elementType: 'checkbox', value_default: false},
				dfloornotlst:{value:false, tagText:'Этаж не последний', elementType: 'checkbox', value_default: false},
				FromMetro:{value:{dWayTypeFromMetro:'',dTimeFromMetro:''}, options:[{name:'0',label:'Пешком'},{name:'1',label:'На транспорте'}], tagText:'От метро', elementType: 'fromMetro', value_default: {dWayTypeFromMetro:'',dTimeFromMetro:''}}, // dWayTypeFromMetro=1&dTimeFromMetro=222
				floor:{value:{min:'',max:''}, map_min:'dfloorfrom', map_max:'dfloorto', tagText:'Этаж', elementType: 'input-range', value_default: {min:'',max:''}},
				stotal:{value:{min:'',max:''}, map_min:'dstotal', map_max:'', tagText:'Площадь общая', elementType: 'input-range', value_default: {min:'',max:''}},
				skitchen:{value:{min:'',max:''}, map_min:'dskitchen', map_max:'', tagText:'Площадь кухни', elementType: 'input-range', value_default: {min:'',max:''}},
				amount:{value:{min:'',max:''}, map_min:'dminamount', map_max:'dmaxamount', tagText:'Стоимость', elementType: 'input-range', value_default: {min:'',max:''}},
				dinvestments:{value:{min:'',max:''}, map_min:'dinvestmentsmin', map_max:'dinvestmentsmax', tagText:'Инвестиции', elementType: 'input-range', value_default: {min:'',max:''}},
				dgk:{value:'', elementType: 'input-hidden-mdgd', catalog:'CAT_COMPLEX', options:[], tagText:'ЖК', value_default: ''}, // они там через ; перечисляются например value="all-inclusive-lider-grupp;ariosto;vesna-2"
				ddev:{value:'', elementType: 'input-hidden-mdgd', catalog:'CAT_DEV', options:[],tagText:'Застройщик', value_default: ''},
				ddist:{value:'', elementType: 'input-hidden-mdgd', catalog:'CAT_DIST_TR', options:[],tagText:'Район', value_default: ''},
				dmetro:{value:'', elementType: 'input-hidden-mdgd',catalog:'CAT_METRO', options:[], tagText:'Метро', value_default: ''},
			},
		};
	},
	computed: {
		dmaxamount(){
			return this.objFilterData.amount.value.max;
		},
		dminamount(){
			return this.objFilterData.amount.value.min;
		},
		bInComplexPage(){
			if(location.pathname.indexOf('/object/complex/') != -1) return true;
			return false;
		},
	},
	watch: {
		// dmaxamount(val){
		// 	val = this.$GVO.str_replace(' ','',val);
		// 	let number1 = this.$GVO.number_format(val,0,'.',' ');
		// 	if(number1 == 0 ){ number1= ''; }
		// 	this.objFilterData.amount.value.max = number1;
		// },
		// dminamount(val){
		// 	val = this.$GVO.str_replace(' ','',val);
		// 	let number1 = this.$GVO.number_format(val,0,'.',' ');
		// 	if(number1 == 0 ){ number1= ''; }
		// 	this.objFilterData.amount.value.min = number1;
		// },
		complex_corp_options(val){
			this.objFilterData.dcorptr.options = val;
		}
	},
	methods: {
		findTag(tag){
			for (let i = 0; i < this.filterTags.length; i++) {
				const elTag = this.filterTags[i];
				if(/*elTag.name == tag.name && */elTag.param_id == tag.param_id) return i;
			}
			return -1;
		},
		translateTags(data){
			let strValue = this.objFilterData[data.selectedType].value;
			let masValue = strValue.split(';');
			for (let i = 0; i < masValue.length; i++) {
				masValue[i] = this.$GVO.GetCat(this.objFilterData[data.selectedType].catalog,masValue[i]).name;
			}
			strValue = masValue.join(';');
			return strValue;
		},
		OnBigSearch(data){
			let masTmp = [];
			if(typeof this.objFilterData[data.selectedType] != 'undefined'){
				let strValue = this.translateTags(data);

				let tag = {name: `${this.objFilterData[data.selectedType].tagText}: ${strValue}`, param_id: data.selectedType};
				if(this.findTag(tag) != -1) this.filterTags.splice(this.findTag(tag), 1); // закрываем старый тег

				if(this.objFilterData[data.selectedType].value != ''){
					masTmp = this.objFilterData[data.selectedType].value.split(';');
				}
				masTmp.push(data.selectedVal);
				this.objFilterData[data.selectedType].value = masTmp.join(';');

				this.BigSearch.inputText='';
				strValue = this.translateTags(data);

				tag = {name: `${this.objFilterData[data.selectedType].tagText}: ${strValue}`, param_id: data.selectedType};
				this.filterTags.push(tag);
			}
		},
		handleClose(tag,bApply=true) { // переделать всё на this.$GVO.unlinkObject(this.objFilterData[tag.param_id].value_default)
			if(this.objFilterData[tag.param_id].elementType == 'input-range'){
				this.objFilterData[tag.param_id].value.min = '';
				this.objFilterData[tag.param_id].value.max = '';
			} else if(this.objFilterData[tag.param_id].elementType == 'checkbox'){
				this.objFilterData[tag.param_id].value = false;
			} else if(this.objFilterData[tag.param_id].elementType == 'fromMetro'){
				this.objFilterData[tag.param_id].value = this.$GVO.unlinkObject(this.objFilterData[tag.param_id].value_default);
			} else {
				this.objFilterData[tag.param_id].value = '';
			}
			this.filterTags.splice(this.findTag(tag), 1);
			if(bApply) this.OnFilterApply();
		},
		setOptCount(data=false){ // тут не только считается количество параметров в фильтре. НО и отрисовка тегов
			if(!data){
				this.objGetParams = this.$GVO.GetAllGet();
			}else{
				this.objGetParams = data;
			}
			if (!this.$GVO.isEmpty(this.objGetParams)) {
				let masKeys = Object.keys(this.objGetParams);
				//console.log('setOptCount_masKeys',masKeys);
				let iOptsCount = 0;
				this.filterTags = [];
				if(typeof this.masExcl != 'undefined'){
					this.masExcludeParams = [...this.masExcludeParams, ...this.masExcl];
				}
				for (let i = 0; i < masKeys.length; i++) {
					if(this.masExcludeParams.indexOf(masKeys[i]) === -1){				
						if(masKeys[i] == 'dnotworkgk' && this.objGetParams[masKeys[i]] == 0) continue; //костыль для ЖК c кураторми и без
						
						if(this.objGetParams[masKeys[i]] !== false && this.objGetParams[masKeys[i]] !== 'false'){
							//console.log('setOptCount_masKeys_i',masKeys[i]);
							let element = this.getFilterDataElement(masKeys[i]);
							//console.log('setOptCount_element',element);
							let bInTags = false;
							for (let iTag = 0; iTag < this.filterTags.length; iTag++) {
								if(this.filterTags[iTag].param_id == element.param_id){
									bInTags = true;
								}
							}
							if(!bInTags){
								iOptsCount++;
								let tag = {name: `${element.tagText}: ${element.value}`, param_id: element.param_id};
								if(element.elementType == 'input-range'){
									let strText = '';
									if(!this.$GVO.isEmpty(element.value.min)){
										strText += 'от '+element.value.min;
									}
									if(!this.$GVO.isEmpty(element.value.max)){
										strText += ' до '+element.value.max;
									}
									tag = {name: `${element.tagText}: ${strText}`, param_id: element.param_id};
								} else if(element.elementType == 'checkbox'){
									if(element.value == true){
										tag = {name: element.tagText, param_id: element.param_id};
									}else{
										tag = null;
									}
								} else if(element.elementType == 'select'){
									let strText = '';
									for (let iSel = 0; iSel < element.options.length; iSel++) {
										//if(element.options[iSel].value == element.value) strText = element.options[iSel].label;
										if(element.value.indexOf(element.options[iSel].value) != -1) strText += element.options[iSel].label+';';
									}
									tag = {name: `${element.tagText}: ${strText.slice(0, -1)}`, param_id: element.param_id};
								} else if(element.elementType == 'input-hidden-mdgd'){
									let strText = this.translateTags({selectedType: element.param_id});
									tag = {name: `${element.tagText}: ${strText}`, param_id: element.param_id};
								} else if(element.elementType == 'fromMetro'){
									let strText = '';
									if(element.value.dWayTypeFromMetro == '0'){
										strText = 'пешком';
									}else{
										strText = 'на транспорте';
									}
									tag = {name: `${element.tagText}: ${strText} ${element.value.dTimeFromMetro} мин`, param_id: element.param_id};
								}
								if(tag != null ) this.filterTags.push(tag);
							}						
						}
					}
				}
				this.optCount = iOptsCount;
			} else {
				this.optCount = '';
				this.filterTags = [];
			}
		},
		getFilterDataElement(strKey){
			if (this.objFilterData.hasOwnProperty(strKey)){
				this.objFilterData[strKey].param_id = strKey;
				return this.objFilterData[strKey];
			} else if(strKey == 'dfloorfrom' || strKey == 'dfloorto' || strKey == 'dstotal' || strKey == 'dskitchen' || strKey == 'dsbalcon' || strKey == 'dminamount' || strKey == 'dmaxamount' || strKey == 'dinvestmentsmin' || strKey == 'dinvestmentsmax'){ // установка параметров в компонент "отдо" ReInputRange
				for (const keyInFlt in this.objFilterData) {
					if (this.objFilterData.hasOwnProperty(keyInFlt) && this.objFilterData[keyInFlt].elementType=='input-range') {
						if ( (typeof this.objFilterData[keyInFlt].map_min != 'undefined' && this.objFilterData[keyInFlt].map_min == strKey) || (typeof this.objFilterData[keyInFlt].map_max != 'undefined' && this.objFilterData[keyInFlt].map_max == strKey) ) {
							this.objFilterData[keyInFlt].param_id = Object.keys(this.objFilterData).find(key => this.objFilterData[key] === this.objFilterData[keyInFlt]);
							return this.objFilterData[keyInFlt];
						}
					}
				}
			} else if(strKey == 'dWayTypeFromMetro' || strKey == 'dTimeFromMetro'){
				this.objFilterData['FromMetro'].param_id = 'FromMetro';
				return this.objFilterData['FromMetro'];
			}
		},
		ShowFilter(){
			this.bShowFilter = !this.bShowFilter;
		},
		SetFilterParams(){ // загружает значения в фильтр из ГЕТ строки
			for (const key in this.objGetParams) {
				if (this.objGetParams.hasOwnProperty(key)) {
					let element = this.getFilterDataElement(key);
					//console.log(key,element);
					if (this.objFilterData.hasOwnProperty(key)) {
						if(this.objGetParams[key] != ''){
							if(key == 'drooms' || key == 'ddecoration' || key == 'dbanks'){
								this.objFilterData[key].value = this.objGetParams[key].split(';');
							} /*else if(key == 'ddecoration' || key == 'dbanks'){
								this.objFilterData[key].value = this.objGetParams[key].split(';');
							} */else {
								if(element.elementType == 'input-hidden-mdgd'){
									this.objFilterData[key].value = this.objGetParams[key];
								}else {
									if (typeof this.objFilterData[key].value == 'boolean') {
										this.objFilterData[key].value = parseInt(this.objGetParams[key])==0?false:true;
									} else {
										this.objFilterData[key].value = this.objGetParams[key];
									}
								}
							}
						}
					} else if(typeof element !='undefined' && element.elementType == 'input-range'){
						for (const keyInFlt in this.objFilterData) {
							if (this.objFilterData.hasOwnProperty(keyInFlt)) {
								if (typeof this.objFilterData[keyInFlt].map_min != 'undefined' && this.objFilterData[keyInFlt].map_min == key) {
									this.objFilterData[keyInFlt].value.min = this.objGetParams[key];
								}
								if (typeof this.objFilterData[keyInFlt].map_max != 'undefined' && this.objFilterData[keyInFlt].map_max == key) {
									this.objFilterData[keyInFlt].value.max = this.objGetParams[key];
								}
							}
						}
					} else if(key == 'dWayTypeFromMetro' || key == 'dTimeFromMetro'){
						this.objFilterData['FromMetro'].value[key] = this.objGetParams[key];
					}
				}
			}
			this.OnFilterApply();
		},
		ApplyFilterParams(){ // подготавливает значения из фильтра для ГЕТ строки
			for (const key in this.objFilterData) {
				if (this.objFilterData.hasOwnProperty(key)) {
					if(key=='AddComplexMinFlatsBig'){
						if(this.objFilterData.dSearchType.value=='complex'){
							this.objFilterData.AddComplexMinFlatsBig.value='1';
						}else{
							this.objFilterData.AddComplexMinFlatsBig.value='';
							delete this.objGetParams[key];
						}
					}
					let element = this.getFilterDataElement(key);
					if(element.elementType == 'input-range'){
						if(typeof this.objFilterData[key].map_min != 'undefined' && this.objFilterData[key].map_min != ''){
							if(!this.$GVO.isEmpty(this.objFilterData[key].value.min)){
								this.objGetParams[this.objFilterData[key].map_min] = this.objFilterData[key].value.min;
							}
						}
						if(typeof this.objFilterData[key].map_max != 'undefined' && this.objFilterData[key].map_max != ''){
							if(!this.$GVO.isEmpty(this.objFilterData[key].value.max)){
								this.objGetParams[this.objFilterData[key].map_max] = this.objFilterData[key].value.max;
							}
						}

						if(this.$GVO.isEmpty(element.value.min)) delete this.objGetParams[element.map_min];
						if(this.$GVO.isEmpty(element.value.max)) delete this.objGetParams[element.map_max];
					}else if(element.elementType == 'checkbox'){
						if(element.value === true){
							this.objGetParams[key] = this.objFilterData[key].value===true?1:0;
						}else{
							if(key != 'dnotworkgk'){
								delete this.objGetParams[key];
							}else{
								this.objGetParams[key] = this.objFilterData[key].value===true?1:0;
							}
						}
					}else if((key == 'drooms' || key == 'ddecoration' || key == 'dbanks') && this.objFilterData[key].value.length > 0){
						this.objGetParams[key] = this.objFilterData[key].value.join(';');
					}else if(element.elementType == 'fromMetro'){
						if(typeof this.objFilterData[key].value.dTimeFromMetro != 'undefined' && this.objFilterData[key].value.dTimeFromMetro != ''){
							this.objGetParams['dTimeFromMetro'] = this.objFilterData[key].value.dTimeFromMetro;
							if(typeof this.objFilterData[key].value.dWayTypeFromMetro == 'undefined' || this.objFilterData[key].value.dWayTypeFromMetro == ''){
								this.objFilterData[key].value.dWayTypeFromMetro == '0';
							}
							this.objGetParams['dWayTypeFromMetro'] = this.objFilterData[key].value.dWayTypeFromMetro;
						}else{
							delete this.objGetParams['dWayTypeFromMetro'];
							delete this.objGetParams['dTimeFromMetro'];
						}
					}else{
						if(!this.$GVO.isEmpty(this.objFilterData[key].value)){
							this.objGetParams[key] = this.objFilterData[key].value;
						}else{
							delete this.objGetParams[key];
						}
					}
				}
			}
			this.bShowFilter = false;
		},
		OnFilterApply(){ // применяет параметры из фильтра и запускает запрос к АПИ
			//console.log('OnFilterApply in filter',this.$GVO.GetAllGet());
			if(typeof this.$GVO.GetAllGet().dSearchType !='undefined' && this.objFilterData.dSearchType.value != this.$GVO.GetAllGet().dSearchType) {
				this.objFilterData.dSearchType.value = this.$GVO.GetAllGet().dSearchType;
			}

			if(typeof this.$GVO.GetAllGet().task_id !='undefined') {
				//без этого блока, при сбрасывании фильтра через тег "Сбросить всё", обнуляться эти параметры по задачам -- они важны при выполнении задачи с презентациями
				this.objGetParams.task_id = this.$GVO.GetAllGet().task_id;
				this.objGetParams.taskend_id = this.$GVO.GetAllGet().taskend_id;
				this.objGetParams.client_id = this.$GVO.GetAllGet().client_id;
				this.objGetParams.service_id = this.$GVO.GetAllGet().service_id;
			}
			
			if(typeof this.objGetParams['show_pres'] != 'undefined') delete this.objGetParams['show_pres'];
			//console.log('OnFilterApply in filter',this.objGetParams);
			this.ApplyFilterParams();
			this.setOptCount(this.objGetParams);
			//console.log(this.objGetParams);
			if(location.search.substr(1) != this.$GVO.ObjToQueryString(this.objGetParams).substr(1)){
				this.$emit('change',this.$GVO.ObjToQueryString(this.objGetParams).substr(1));
			}
		},
		OnFilterReset(){
			//console.log('OnFilterReset in filter');
			// console.log('this.objGetParams.task_id', this.objGetParams.task_id);
			if(typeof this.objGetParams.task_id != 'undefined'){
				let dmp_objGetParams = {'task_id':'','taskend_id':'','client_id':'','service_id':''};
				dmp_objGetParams.task_id = this.$GVO.unlinkObject(this.objGetParams.task_id);
				dmp_objGetParams.taskend_id = this.$GVO.unlinkObject(this.objGetParams.taskend_id);
				dmp_objGetParams.client_id = this.$GVO.unlinkObject(this.objGetParams.client_id);
				dmp_objGetParams.service_id = this.$GVO.unlinkObject(this.objGetParams.service_id);
				this.objGetParams = {};
				this.objGetParams =  this.$GVO.unlinkObject(dmp_objGetParams);
				// console.log('OnFilterReset dmp_objGetParams', dmp_objGetParams);
				// console.log('OnFilterReset objGetParams', this.objGetParams);
			}else{
				this.objGetParams = {};
			}
			for (const key in this.objFilterData) {
				if (this.objFilterData.hasOwnProperty(key) && this.masExcludeParams.indexOf(key) == -1) {
					this.objFilterData[key].value = this.$GVO.SafeParseJson(JSON.stringify(this.objFilterData[key].value_default));
				}
			}
			this.OnFilterApply();
		},
		SetCats(strCat){
			for (const key in this.objFilterData) {
				if (this.objFilterData.hasOwnProperty(key)) {
					if(typeof this.objFilterData[key].catalog != 'undefined' && this.objFilterData[key].catalog == strCat){
						this.objFilterData[key].options = this.$GVO.getCatToSelect(this.objFilterData[key].catalog);
					}
				}
			}
		},
		doEnterThings(e,dopParam) {
			this.OnFilterApply();	
			// console.log("enter was pressed on page ", location.pathname);
		},
	},
	mounted() {
		this.objGetParams = this.$GVO.GetAllGet();
		
		this.$GVO.LoadCatPromise('CAT_ROOMS').then((ret)=>{ // надо будет переделать во что-то красивое в прелоаде в мэйне
			this.SetCats('CAT_ROOMS'); 
			this.$GVO.LoadCatPromise('CAT_DECORATION').then((ret)=>{
				this.SetCats('CAT_DECORATION');
				this.$GVO.LoadCatPromise('CAT_BANKS').then((ret)=>{
					this.SetCats('CAT_BANKS');
					this.$GVO.LoadCatPromise('CAT_COMPLEX').then((ret)=>{
						this.SetCats('CAT_COMPLEX');
						this.$GVO.LoadCatPromise('CAT_D_ENDS').then((ret)=>{
							this.SetCats('CAT_D_ENDS');
							this.$GVO.LoadCatPromise('CAT_DEV').then((ret)=>{
								this.$GVO.LoadCatPromise('CAT_DIST_TR').then((ret)=>{
									this.$GVO.LoadCatPromise('CAT_METRO').then((ret)=>{
										this.SetFilterParams();
									}).catch(errorRet => console.error(errorRet));
								}).catch(errorRet => console.error(errorRet));
							}).catch(errorRet => console.error(errorRet));
						}).catch(errorRet => console.error(errorRet));
					}).catch(errorRet => console.error(errorRet));
				}).catch(errorRet => console.error(errorRet));
			}).catch(errorRet => console.error(errorRet));
		}).catch(errorRet => console.error(errorRet));
	}
};
</script>
<style scoped>
.majorFilter-card {border: 1px solid #01b0e0;}
.majorFilter {display: flex; justify-content: space-between;}
.firstFilter-row {display: flex; flex-wrap: wrap; width: 100%;}
.filter-shown {display: block;}
.filter-hidden {display: none;}
.map-search .btn {margin-top: 0px; width: 207px; padding-left: 5px;}
.allFilters {justify-content: flex-end;}
.allFilters .btn, .applyFilter .btn {margin-top: 0px; margin-right: 15px;}

.map-search >>> .btn.btn-simple {border-color: #2b3553; color: rgba(255, 255, 255, 0.8); font-weight: 400;}
.white-content .map-search >>> .btn.btn-simple {color: #6062667c;}
.map-search >>> .btn.btn-simple:hover {border-color: #01b0e0; color: rgba(1, 176, 224, 0.6); font-weight: 400;}
.ssopage >>> .form-group input:hover, .input-group:hover {border: 1px solid #01b0e0;}

.ssopage >>> .el-select .el-input.is-focus .el-input__inner:hover, .el-input .el-input--large .el-input--suffix:hover {border: 1px solid #01b0e0; }
.ssopage >>> .el-input .el-input--large .el-input--suffix .is-focus {border: 1px solid #01b0e0;}
.ssopage >>> .el-select .el-input.is-focus .el-input__inner  {border: 1px solid #01b0e0;}
.ssopage >>> .el-select__input .is-large:hover > .select-primary.el-select .el-input input {border: 1px solid #01b0e0;}
/*HOVER FOR .el-icon-circle-colse*/
.ssopage >>> .el-input__suffix-inner:hover i {font-size: 20px; color: #F84E54;}

/*.ReInputSearchDropType:hover {border: 1px solid #01b0e0; border-radius: 6px;}*/
/*.ReInputSearchDropType:hover {margin-bottom: 0; border: 1px solid #01b0e0; border-radius: 6px;}*/
.moreFilter >>> .el-select .el-input .el-input__icon:hover, .majorFilter >>> .el-select .el-input .el-input__icon:hover {font-size: 24px; color: #F84E54;}

.ssopage >>>  .dropdown-menu .tim-icons {margin-top: -10px;}
.flat-corp-row, .filter-row {display: flex; flex-wrap: wrap;}

.ssopage >>> .outline-secondary {border-right: 1px solid #2b3553}
.ssopage >>> .outline-secondary:hover {border: 1px solid #01B0E0;}
.ssopage >>> .outline-secondary:focus {border-right: 1px solid #01B0E0; border-left: 1px solid #01B0E0;}
.ssopage >>> .flat-corp-row .form-control:hover, .input-group-text:focus {border: none;}
.ssopage >>> .flat-corp-row .input-group:hover {border: 1px solid #01B0E0; border-radius: 6px;}
.ssoModuleFilter >>> hr {border-top: 1px solid #01B0E0!important;}

.sLabelText label {font-size: .9rem;}
.allFilters .btn {margin-bottom: 10px;}

.majorFilter-card >>> .el-select .el-input__inner {height: 38px;}

@media (max-width: 768px) {	
	.map-search, .year-search, .type-search, .price-search, .base-search, .flat-corp-width {margin-right: 0px !important; width: 100%;}
	.map-search .btn.btn-simple {width: 100%;}
	.majorFilter-card >>>  .overflow-overlay {max-height: 110px!important;}
}
@media (max-width: 575px) {
	.filter-row > .col-md-4, .filter-row > .col-sm-6 {padding-right: 0px;}
	.applyFilter, .allFilters, .allFilters .btn, .applyFilter .btn {width: 100%;}
	.type-search {margin-bottom: 20px !important;}
}



</style>
